import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import {
  AdditionalDomainType, CloudflareCertificateType,
} from '../../../../__generated__/graphql';
import { INSTANCE_QUERY } from '../../../../api/queries/instances';
import { LoadingIndicator } from '../../../../layout';
import CloudflareCertificateCard from './CloudflareCertificateCard';

export default function CloudflareCertificates() {
  const { instanceId } = useParams();

  const { data: instanceData, loading } = useQuery(INSTANCE_QUERY, {
    variables: { instance: instanceId },
  });

  const instance = (instanceData
    && instanceData.instance
    && instanceData.instance.response) ? instanceData.instance.response : null;

  if (loading) {
    return <LoadingIndicator className="flex justify-center items-center" />;
  }

  if (!instance) {
    return null;
  }

  const cloudflareDomains: string[] = [
    ...(instance.isCloudflareProxied ? [instance.mainDomain] : []),
    ...instance.aliasDomains
      .filter((item: AdditionalDomainType) => item.isCloudflareProxied)
      .map((item: AdditionalDomainType) => item.name),
    ...instance.redirectDomains
      .filter((item: AdditionalDomainType) => item.isCloudflareProxied)
      .map((item: AdditionalDomainType) => item.name),
  ];

  const certificatesByDomain: Record<string, boolean> = (
    instance.cloudflareCertificates || []
  ).reduce((acc: Record<string, boolean>, cert: CloudflareCertificateType) => ({
    ...acc,
    [cert.domain]: true,
  }), {});

  return (
    <div className="px-4 py-6 space-y-4 sm:px-6 sm:py-4">
      {!cloudflareDomains.length && (
        <p className="text-sm text-slate-500">
          No domain on this Instance is currently marked as Cloudflare-proxied.
          Mark a domain as Cloudflare-proxied on the Update Instance form to upload
          its Origin CA certificate here.
        </p>
      )}
      {cloudflareDomains.map((domain) => (
        <CloudflareCertificateCard
          key={domain}
          domain={domain}
          hasCertificate={!!certificatesByDomain[domain]}
        />
      ))}
    </div>
  );
}
